import { Search } from "@components/Icons"
import { breakpoints, theme } from "@config/theme"
import { rgba } from "polished"
import styled from "styled-components"

export const Container = styled.div`
  padding: 1rem 0;
  width: 100%;
  display: flex;
  align-items: center;
  color: ${theme.colors.text.dark};
  border-bottom: 1px solid ${theme.colors.softGrey};
  max-width: rem(1200);
  margin: 0 auto;
  width: 100%;
  margin-bottom: 1rem;

  @media screen and (min-width: ${breakpoints.medium}) {
    padding: 2rem 0;
    border-bottom: none;
    margin-bottom: 0;
  }
`

export const Icon = styled(Search)`
  width: 2rem;
  margin-right: 0.5rem;

  @media screen and (min-width: ${breakpoints.small}) {
    width: 3.25rem;
    margin-right: 1.25rem;
  }
`

export const Form = styled.form`
  flex-grow: 1;
`

export const Input = styled.input`
  background: transparent;
  width: 100%;
  font-size: 1.25rem;
  font-family: ${theme.fonts.serif};
  border: none;
  outline: 0;

  &::placeholder {
    color: ${theme.colors.softGrey};
    transition: color 0.2s ease-in-out;
  }

  &:hover {
    &::placeholder {
      color: ${rgba(theme.colors.text.light, 0.5)};
    }
  }

  @media screen and (min-width: ${breakpoints.small}) {
    font-size: 2.5rem;
  }
`
